import * as React from 'react';
var PrivateContext = /*#__PURE__*/React.createContext({});
export default PrivateContext;